import React from 'react';
import PropTypes from 'prop-types';

import Exchange from '../../../models/Exchange';
import Availability from '../../../models/Availability';

import GpExchangePopup from './GpExchangePopup';

const ModifyGpExchangeModalWrapper = ({
    convExchange,
    convId,
    firstName,
    updateLoadingState,
    availabilities,
    userTotalGp,
    isCollection,
    fetchConversation
}) => {
    const [showGpModificationFormModal, setShowGpModificationFormModal] = React.useState(true);

    const toggleGpExchangeModificationForm = () => {
        setShowGpModificationFormModal((currentState) => !currentState);
    };

    return (
        <GpExchangePopup
            showModificationFormModal={showGpModificationFormModal}
            closeModificationFormModal={toggleGpExchangeModificationForm}
            convExchange={convExchange}
            convId={convId}
            firstName={firstName}
            availabilities={availabilities}
            updateLoadingState={updateLoadingState}
            userTotalGp={userTotalGp}
            isCollection={isCollection}
            fetchConversation={fetchConversation}
        />
    );
};

ModifyGpExchangeModalWrapper.propTypes = {
    firstName: PropTypes.string.isRequired,
    convExchange: PropTypes.instanceOf(Exchange).isRequired,
    convId: PropTypes.number.isRequired,
    availabilities: PropTypes.arrayOf(PropTypes.instanceOf(Availability)).isRequired,
    updateLoadingState: PropTypes.func.isRequired,
    userTotalGp: PropTypes.number.isRequired,
    isCollection: PropTypes.bool.isRequired,
    fetchConversation: PropTypes.func.isRequired
};

export default ModifyGpExchangeModalWrapper;
